'use client'

import { useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'

import Bg1 from '@/assets/images/affluentBg.webp'
import Bg2 from '@/assets/images/affluentBg2.webp'
import AffluentMobile1 from '@/assets/images/affluentmobile1.webp'
import AffluentMobile2 from '@/assets/images/affluentmobile2.webp'
import LeftIcon from '@/assets/images/left-icon.svg'
import RightIcon from '@/assets/images/right-icon.svg'
import { PrimaryButton } from '@/components/buttons'
import { SlideCarousel } from '@/components/carousel/SlideCarousel'

import '@/sections/sections.css'
import './home.css'

interface AffluentSlide {
  title: string
  description: string
  ctaText: string
  ctaLink: string
  backgroundImage: string
  backgroundImageMobile: string
  backgroundColor?: string
}

const slidesData: AffluentSlide[] = [
  {
    title: 'Begin your Diamond Affluent journey today',
    description:
      'Discover tailored Shariah-compliant wealth solutions, dedicated relationship expertise, and exclusive privileges designed around your financial ambitions. Gain exclusive access by maintaining a minimum Total Relationship Balance (TRB) of RM1 million with alrajhi bank Malaysia.',
    ctaText: 'Learn more',
    ctaLink: '/personal/affluent',
    backgroundImage: Bg1.src,
    backgroundImageMobile: AffluentMobile1.src
  },
  {
    title: 'Elevate your everyday banking with MY alrajhi',
    description:
      'Discover a simpler way to manage your money. Reach your savings goals faster with our Savings Pots, make payments seamlessly, and enjoy Shariah-compliant banking right in your hands.',
    ctaText: 'Learn more',
    ctaLink: '/MY-alrajhi',
    backgroundImage: Bg2.src,
    backgroundImageMobile: AffluentMobile2.src,
    backgroundColor: '#F0F7FD'
  }
]

function AffluentSlider({ slideData = slidesData }: { slideData?: AffluentSlide[] }) {
  const [currentSlide, setCurrentSlide] = useState(0)

  if (!slideData || slideData.length === 0) return null

  const activeSlide = slideData[currentSlide]
  const isFirstSlide = currentSlide === 0
  const isLastSlide = currentSlide === slideData.length - 1

  return (
    <section
      className="section affluent-slider py-md-5 py-3"
      style={
        {
          '--affluent-slide-bg': `url(${activeSlide.backgroundImage})`,
          '--affluent-mobile-bg-color': activeSlide.backgroundColor || 'transparent'
        } as React.CSSProperties
      }
    >
      <Container>
        <SlideCarousel
          className="affluent-carousel-z"
          index={currentSlide}
          onIndexChange={setCurrentSlide}
        >
          {slideData.map(slide => (
            <Row key={slide.title} className="text-start pt-5 g-5 align-items-center">
              <Col md={6}>
                <h2 className="affluent-title fw-bold mb-2 fs-26 lh-base">{slide.title}</h2>

                <p className="affluent-desc py-2 fs-18">{slide.description}</p>

                <PrimaryButton
                  text={slide.ctaText}
                  href={slide.ctaLink}
                  srText={slide.title}
                  classname="btn btn-primary affluent-cta mt-3"
                  icon={undefined}
                  id={undefined}
                  disabled={undefined}
                  style={undefined}
                />
              </Col>
            </Row>
          ))}
        </SlideCarousel>
      </Container>

      {/* Mobile image — always in DOM, CSS hides on desktop to avoid hydration mismatch */}
      <Col xs={12} className="affluent-image-wrapper affluent-mobile-image p-0">
        <img
          src={activeSlide.backgroundImageMobile}
          alt=""
          width={2225}
          height={1288}
          className={`affluent-mobile-fullscreen${
            activeSlide.backgroundImageMobile === AffluentMobile2.src ? ' affluent-mobile2-mt' : ''
          }`}
        />
      </Col>

      <Container>
        <Row className="mt-0 mt-md-5">
          <div className="affluent-nav mt-lg-5 mt-0">
            <button
              className={`arrow-btn ${isFirstSlide ? 'disabled' : 'active'}`}
              onClick={() => !isFirstSlide && setCurrentSlide(v => v - 1)}
              aria-label="Previous slide"
            >
              <img src={LeftIcon.src} alt="Previous" width={16} height={16} />
            </button>

            <button
              className={`arrow-btn ${isLastSlide ? 'disabled' : 'active'}`}
              onClick={() => !isLastSlide && setCurrentSlide(v => v + 1)}
              aria-label="Next slide"
            >
              <img src={RightIcon.src} alt="Next" width={16} height={16} />
            </button>
          </div>
        </Row>
      </Container>
    </section>
  )
}

export default function AffluentSliderSection() {
  return <AffluentSlider slideData={slidesData} />
}
